<template>
    <vx-card title="Tasting Forms">
          <div
            ref="filterCard"
            class="user-list-filters mb-8"
            :collapse-action="true"
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                <label class="text-sm opacity-100 text-bold"
                  >General Search</label
                >
                <vs-input
                  type="text"
                  class="w-full"
                  v-model="filters['search']"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                <label class="text-sm opacity-100 text-bold">From</label>
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="filters['from']"
                  placeholder="Choose Date"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                <label class="text-sm opacity-100 text-bold">To</label>
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="filters['to']"
                  placeholder="Choose Date"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">status</label>
              <v-select
                :options="statusOptions"
                v-model="filters['status']"
                :reduce="(option) => option.value"
                label="label"
                placeholder="Select status"
                :clearable="false"
                class="w-full vs-select-lg"
              />
            </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full md:w-6/6">
                
                  <vs-button
                    class="float-right mr-4"
                    size="small"
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    v-on:click="filters = {}"
                    >CLEAR</vs-button
                  >
                
              </div>
            </div>
          </div>
          <template slot="actions">
            <vs-button
              class="mr-4"
              @click="onCLickCreateTest"
              color="primary"
              type="filled"
              v-can="'create-edit-quality-control-tastings'"
              >Create</vs-button
            >
          </template>
          <vs-table
            stripe
            :data="testList"
            :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container"
            id="mass-balance-audit-table"
            @sort="handleSort"
          >
            <template slot="thead">
              <vs-th>BATCH TYPE</vs-th>
              <vs-th>BATCH CODE</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                <vs-td>
                  {{ tr.batch_type }}
                </vs-td>
                <vs-td>
                  {{ tr.batch_code }}
                </vs-td>
                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-4/5">
                    <vs-table
                      :hoverFlat="true"
                      class="mt-8 mb-8"
                      :data="tr.tastings"
                    >
                      <template slot="thead">
                        <vs-th>CODE</vs-th>
                        <vs-th>DONE BY</vs-th>
                        <vs-th>STATUS</vs-th>
                        <vs-th>TYPE</vs-th>
                        <vs-th>CREATED AT</vs-th>
                        <vs-th>ACTIONS</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                          <vs-td>
                            {{ tr.code }}
                          </vs-td>

                          <vs-td>
                            {{ tr.done_by.name }}
                          </vs-td>

                          <vs-td>
                            {{ tr.status }}
                          </vs-td>

                          <vs-td>
                            {{ getBatchType(tr.batch_type) }}
                          </vs-td>

                          <vs-td>
                            {{ __dateTimeFormatterToDate(tr.created_at) }}
                          </vs-td>

                          <vs-td>
                            <div class="vx-row">
                              <vx-tooltip
                                class="text-primary cursor-pointer"
                                text="View/Update"
                                position="top"
                              >
                                <vs-button
                                  @click.stop="onClickViewTest(tr.id)"
                                  size="small"
                                  icon-pack="feather"
                                  icon="icon-eye"
                                ></vs-button>
                              </vx-tooltip>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
          <TastePanelCreate ref="tastePanelCreate" @refresh="refresh" />
          <vs-pagination
            v-on:changeMaxItems="changePage"
            :size-array="meta.total ? meta.total : 20"
            :max-items="perPage"
            description-body="Rows per page"
            description-connector="of"
            description-title="Records"
            description
            :description-items="descriptionItems"
            :total="meta.last_page ? meta.last_page : 0"
            v-model="page"
            class="p-5"
          >
          </vs-pagination>
        </vx-card>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import ErrorMessages from "@/mixins/ErrorMessages";
import Filter from "@/mixins/filter";
import TastePanelCreate from "@/components/popups/TastePanel/TastePanelCreate.vue";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");

export default {
  name: "TastingForm",
  data() {
    return {
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: "",
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {},
      testList: [],
      statusOptions: [],
    };
  },
  components: {
    flatPickr,
    vSelect,
    TastePanelCreate,
  },
  mixins: [ErrorMessages, Filter],
  async mounted() {
    await this.getTestList(),
    await this.getStatusList();
  },
  methods: {
    refresh() {
      this.getTestList();
    },
    async getTestList() {
      try {
        const response =
          await TriangleTestsRepository.getListOfQualityControlTestingsGroupByType(
            this.filterQuery,
            this.page,
            this.perPage
          );
        this.testList = response.data.data;
        this.meta = response.data.meta;
      } catch (e) {}
    },
    async getStatusList() {
      try {
        const response =
          await TriangleTestsRepository.getFormTestingStatusList();
        this.statusOptions = response.data.data;
      } catch (e) {
        this.convertAndNotifyError(e);
      }
    },
    filterQueryUpdate() {
      if (this.filters.search) {
        this.getTestList();
      }
    },
    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };

      return typeMap[typeString] || "Work Order";
    },
    getBatchCode(data, type) {
      if (!data || !data.batch) return null;

      if (type === "Work Order") {
        return data.batch.work_order_code ? data.batch.work_order_code : null;
      } else {
        return data.batch.code ? data.batch.code : null;
      }
    },
    onCLickCreateTest() {
      this.$refs.tastePanelCreate.openPopup();
    },
    onClickViewTest(id) {
      this.$refs.tastePanelCreate.openPopup(id);
    },
    handleChangePage(page) {
      this.page = page;
      this.getTestList();
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
  }
}

</script>
